import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import {
  ProposalService
} from 'src/app/services/proposal/proposal.service';
import {
  MainService
} from 'src/app/services/main-service.service';
import {
  Router,
  ActivatedRoute
} from '@angular/router';
import {
  BsDatepickerConfig
} from 'ngx-bootstrap/datepicker';
import {
  HttpClient
} from '@angular/common/http';
import {
  DatePipe
} from '@angular/common';
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrls: ['./personal.component.scss']
})
export class PersonalComponent implements OnInit, OnDestroy {
  @Output() formEvent: EventEmitter < any > = new EventEmitter();
  patientData: any = {};
  financeData: any = {};
  settingsData: any;
  salutations: any = [];
  mask: any;
  placeholderChar: any;
  colorTheme = 'theme-blue';
  // dateObject: any;
  bsConfig: Partial < BsDatepickerConfig > ;
  maxDate: Date;
  zips: any[] = [];
  empZips: any[] = [];
  token: any;
  loader: boolean;
  subscription: any;
  subscription2: any;
  subscription3: any;
  ssn_mask: any = [/\d/,/\d/,/\d/,'-',/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/];
  zip_mask: any = [/\d/,/\d/,/\d/,/\d/,/\d/,/\d/];
  LABEL: any;
  is_android_device = /(android)/i.test(navigator.userAgent);
  planInfo: any = {};
  min_phone_length = 7;
  phone_length = 12;
  constructor(
    public proposal: ProposalService,
    public mainService: MainService,
    public route: Router,
    public http: HttpClient,
    public router: ActivatedRoute,
    public toasterService: ToasterService,
    private datePipe: DatePipe
  ) {
    this.token = this.proposal.getToken();
    this.LABEL = this.mainService.LABEL;
    this.subscription = this.mainService.getMsg().subscribe((data: any) => {
      this.settingsData = data;
      this.salutations = this.settingsData.salutation;
    });

    

    this.subscription2 = this.proposal.getData().subscribe((data: any) => {
      this.mainService.setLoader(false);
      this.patientData = data.patients[0];
      this.planInfo = data.planInfo[0];
      this.financeData = data.financing_info[0];
      this.setPatientData();
    });
    this.mask = [
      /[1-9]/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/
    ];
    this.placeholderChar = ' ';
    // this.dateObject = this.proposal.getDates();
    // console.log(this.dateObject);
    // this.months = this.dateObject.months;
    // this.dates = this.dateObject.dates;
    // this.birthYears = this.dateObject.birthYears;

    this.maxDate = new Date();
    // this.maxDate.setFullYear(this.maxDate.getFullYear() - 13);
    this.bsConfig = Object.assign({}, {
      showWeekNumbers: false,
      containerClass: this.colorTheme,
      dateInputFormat: 'MM/dd/yyyy'
    });
  }

  ngOnInit() {
    this.proposal.getPatientUpdatedData().subscribe((data:any)=>{
      console.log(data);
      this.mainService.setLoader(false);
      this.patientData = data.personal;
      this.financeData = data.finance;
      this.setPatientData();
    })
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscription2.unsubscribe();
    if (this.subscription3) {
      this.subscription3.unsubscribe();
    }
  }

  setPatientData() {
    if (sessionStorage.getItem('patientData')) {
      this.patientData = JSON.parse(sessionStorage.getItem('patientData'));
    }
    if (this.patientData.date_of_birth) {
      const a = this.patientData.date_of_birth.split('-');
      this.patientData.dob = new Date(
        parseInt(a[2], 10),
        parseInt(a[0], 10) - 1,
        parseInt(a[1], 10)
      );
    } else {
      this.patientData.dob = '';
    }
    if (!this.patientData.guardian_title) {
      this.patientData.guardian_title = 'None';
    }
    if (!this.patientData.title) {
      this.patientData.title = 'None';
    }
    if (this.patientData.is_minor == null) {
      this.patientData.is_minor = '0';
    } else {
      this.patientData.is_minor = this.patientData.is_minor.toString();
    }
    this.patientData.patient_gender = this.patientData.patient_gender.toString();
    if (this.patientData.patient_mobile.indexOf('+1-') > -1) {
      const phone = this.patientData.patient_mobile.split('-');
      this.patientData.patient_mobile = phone[1];
    } else {
      this.patientData.patient_mobile = this.patientData.patient_mobile.replace(
        /[^0-9]/g,
        ''
      );
    }
    if (this.patientData.employer_mobile != null) {
      if (this.patientData.employer_mobile.indexOf('+1-') > -1) {
        const employerPhone = this.patientData.employer_mobile.split('-');
        this.patientData.employer_mobile = employerPhone[1];
      } else {
        this.patientData.employer_mobile = this.patientData.employer_mobile.replace(
          /[^0-9]/g,
          ''
        );
      }
    } else {
      this.patientData.employer_mobile = '';
    }
  }
  checkPatientData() {
    this.patientData.patient_first_name = this.patientData.patient_first_name.trim();
    this.patientData.patient_last_name = this.patientData.patient_last_name.trim();
    this.patientData.title = this.patientData.title.trim();
    this.patientData.patient_mobile = this.patientData.patient_mobile.trim();
    this.patientData.patient_address = this.patientData.patient_address.trim();
    this.patientData.dl_number = this.patientData.dl_number.trim();
    this.patientData.patient_ssn = this.patientData.patient_ssn.trim();
    this.patientData.employer_name = this.patientData.employer_name.trim();
    this.patientData.employer_mobile = this.patientData.employer_mobile.trim();
    this.patientData.employer_address = this.patientData.employer_address.trim();
    if (parseInt(this.patientData.is_minor, 10) === 1) {
      this.patientData.guardian_first_name = this.patientData.guardian_first_name.trim();
      this.patientData.guardian_last_name = this.patientData.guardian_last_name.trim();
    }
    if (
      !this.patientData.patient_first_name ||
      !this.patientData.patient_last_name ||
      !this.patientData.title ||
      !this.patientData.patient_mobile ||
      !this.patientData.patient_address ||
      !this.patientData.dob ||
      !this.patientData.patient_gender ||
      !this.patientData.city_id ||
      !this.patientData.dl_number ||
      !this.patientData.patient_ssn ||
      this.patientData.patient_ssn.length < 9 ||
      !this.patientData.employer_name ||
      !this.patientData.employer_mobile ||
      !this.patientData.employer_city ||
      !this.patientData.employer_address ||
      // !this.patientData.annual_income ||
      this.patientData.is_minor === undefined ||
      (parseInt(this.patientData.is_minor, 10) === 1 &&
        (!this.patientData.guardian_title ||
          !this.patientData.guardian_first_name ||
          !this.patientData.guardian_last_name))
    ) {
      this.toasterService.message('Please fill all the fields', 2);
      return false;
    } else {
      const patient_mobile = this.patientData.patient_mobile.replace(
        /[^0-9]/g,
        ''
      );
      const employer_mobile = this.patientData.employer_mobile.replace(
        /[^0-9]/g,
        ''
      );
      this.patientData.patient_ssn = this.patientData.patient_ssn.replace(/[^0-9]/g, '');
      let patient_ssn = this.patientData.patient_ssn;
      // if(!this.validateTin(patient_ssn)){
      //   this.toasterService.message('warning', 'Please enter valid SSN number', '');
      //   return false;
      // }
      if(patient_ssn){
        // patient_ssn = patient_ssn.includes("enc_") ? decrypt(patient_ssn) : patient_ssn;
        patient_ssn = patient_ssn.replace(/[^0-9]/g,'');
        console.log(patient_ssn)
        var invalid_ssn = ["002281852", "042103580", "062360749", "078051120", "095073645", "128036045", "135016629", "141186941", "165167999", "165187999", "165207999", "212099999", "165227999", "306302348", "165247999", "189092294", "308125070", "212097694", "549241889", "468288779"];
        if (patient_ssn.trim().length != 9) {
            this.toasterService.message('Please enter valid SSN number', 2);
            return false;
        } else if (/^(.)\1+$/.test(patient_ssn)) {
          this.toasterService.message('Please enter valid SSN number', 2);
            return false;
        } else if (/[a-zA-Z]/.test(patient_ssn)) {
          this.toasterService.message('Please enter valid SSN number', 2);
            return false;
        } else if (patient_ssn.slice(0, 3) == "000" || patient_ssn.slice(0, 3) == "666") {
          this.toasterService.message('Please enter valid SSN number', 2);
            return false;
        } else if (invalid_ssn.indexOf(patient_ssn) >= 0) {
          this.toasterService.message('Please enter valid SSN number', 2);
            return false;
        } else if (parseInt(patient_ssn) >= 987654320 && parseInt(patient_ssn) <= 987654329) {
          this.toasterService.message('Please enter valid SSN number', 2);
            return false;
        } else if (patient_ssn.slice(9, 4) == "0000") {
          this.toasterService.message('Please enter valid SSN number', 2);
            return false;
        }
        // return true;
      }
      if (patient_mobile.length < 10 || employer_mobile.length < 10) {
        this.toasterService.message('Please fill all the fields', 2);
        return false;
      } else {
        this.patientData.patient_mobile_formatted =
          '+1-' + this.patientData.patient_mobile.replace(/[^0-9]/g, '');
        this.patientData.employer_mobile_formatted =
          '+1-' + this.patientData.employer_mobile.replace(/[^0-9]/g, '');
        this.patientData.date_of_birth = this.datePipe.transform(
          this.patientData.dob,
          'MM/DD/YYYY'
        );
        this.patientData.patient_first_name = this.capitalize(this.patientData.patient_first_name);
        this.patientData.patient_last_name = this.capitalize(this.patientData.patient_last_name);
        this.patientData.employer_name = this.capitalize(this.patientData.employer_name);
        if (parseInt(this.patientData.is_minor, 10) === 1) {
          this.patientData.guardian_first_name = this.capitalize(this.patientData.guardian_first_name);
          this.patientData.guardian_last_name = this.capitalize(this.patientData.guardian_last_name);
        }
        sessionStorage.setItem('patientData', JSON.stringify(this.patientData));
        localStorage.setItem('patientData', JSON.stringify(this.patientData));
        this.formEvent.emit(this.patientData);
        this.mainService.setLoader(false);
      }
    }
  }

  capitalize(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  updatePatientData(form: any) {
    if (form.valid) {
      this.checkPatientData();
    } else {
      this.toasterService.message('Please fill all the fields', 2);
      return false;
    }
  }
  getZip(token: string, type: number) {
    if (token.length > 3) {
      this.subscription3 = this.mainService
        .getZipcode({
          zipcode: token
        })
        .subscribe(
          (data: any) => {
            if (type === 1) {
              this.zips = data;
            } else if (type === 2) {
              this.empZips = data;
            }
          },
          (error: any) => {
          }
        );
    } else {
      // const b = [];
      return false;
    }
  }
  selectZip(zip: any) {
    this.patientData.city_id = zip.city_id;
    this.patientData.city = zip.city;
    this.patientData.state_name = zip.state_name;
    this.patientData.zip = zip.zip;
    this.zips = [];
  }
  selectEmpZip(zip: any) {
    this.patientData.employer_city_id = zip.city_id;
    this.patientData.employer_city = zip.city;
    this.patientData.employer_state = zip.state_name;
    this.patientData.employer_zip = zip.zip;
    this.empZips = [];
  }

  validateTin(tin) {
    if(tin){
      // tin = tin.includes("enc_") ? decrypt(tin) : tin;
      tin = tin.replace(/[^0-9]/g,'');
      var invalid_ssn = ["002281852", "042103580", "062360749", "078051120", "095073645", "128036045", "135016629", "141186941", "165167999", "165187999", "165207999", "212099999", "165227999", "306302348", "165247999", "189092294", "308125070", "212097694", "549241889", "468288779"];
      if (tin.trim().length != 9) {
          return false;
      } else if (/^(.)\1+$/.test(tin)) {
          return false;
      } else if (/[a-zA-Z]/.test(tin)) {
          return false;
      } else if (tin.slice(0, 3) == "000" || tin.slice(0, 3) == "666") {
          return false;
      } else if (invalid_ssn.indexOf(tin) >= 0) {
          return false;
      } else if (parseInt(tin) >= 987654320 && parseInt(tin) <= 987654329) {
          return false;
      } else if (tin.slice(9, 4) == "0000") {
          return false;
      }
      return true;
    }
  }

  enterNumberOnly(event) {
    if (event.target.value && event.target.value.length == 1 && event.target.value == 0) {
      return false;
    }
    if (event.target.length > 7) {
      return false;
    }

    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
}
